module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pagination-sm m-t-sm m-b pagination",
    attrs: {
      "aria-invalid": "false"
    }
  }, [_c('li', {
    staticClass: "pagination-first",
    class: {
      disabled: _vm.noPrevious
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.selectPage(1, $event)
      }
    }
  }, [_vm._v("<<")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-prev",
    class: {
      disabled: _vm.noPrevious
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selectPage(parseInt(_vm.atual) - 1, $event)
      }
    }
  }, [_vm._v("<")])]), _vm._v(" "), _vm._l((_vm.totalLimited), function(page) {
    return _c('li', {
      staticClass: "pagination-page",
      class: {
        active: _vm.isAtualPage(page)
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.selectPage(parseInt(page), $event)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-next",
    class: {
      disabled: _vm.noNext
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selectPage(parseInt(_vm.atual) + 1, $event)
      }
    }
  }, [_vm._v(">")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-last",
    class: {
      disabled: _vm.noNext
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selectPage(parseInt(_vm.total), $event)
      }
    }
  }, [_vm._v(">>")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-747cb60a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/Uloc/Pagination.vue
// module id = 1756
// module chunks = 17